
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdi() {



  const cardData =
  {
    keyword: 'Mumbai to Shirdi Cab Service',
    heading: 'AB Ghule Cabs: Mumbai to Shirdi Cab Service',
    headingDescription: 'Planning a spiritual journey to Shirdi? Look no further than AB Ghule Cabs for your Mumbai to Shirdi travel needs. We offer reliable, comfortable, and affordable cab services tailored to ensure your journey is as fulfilling as your destination. With a range of vehicles and professional drivers, we make your trip to one of India’s most revered pilgrimage sites seamless and memorable. Shirdi is approximately 250 km from Mumbai.',

    top: 'Top Places to Visit in Shirdi with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Shirdi Sai Baba Temple",
          description: "The Sai Baba Temple is the heart and soul of Shirdi, attracting millions of devotees from around the world. Dedicated to Sai Baba, a saint known for his teachings of love, unity, and compassion, the temple is a place of immense spiritual significance. Devotees come to seek blessings and experience peace, as the temple houses Sai Baba's idol and is a focal point for various religious ceremonies and rituals."
        },
        {
          title: "Samadhi Mandir",
          description: "The Samadhi Mandir is the sacred place where Sai Baba's mortal remains were laid to rest. This iconic temple exudes a serene and tranquil ambiance, offering a perfect environment for meditation and spiritual reflection. Visitors can feel a strong sense of divine presence here, and the temple continues to be a center for spiritual healing and devotion for millions of Sai Baba’s followers."
        },
        {
          title: "Dixit Wada Museum",
          description: "The Dixit Wada Museum offers a deep dive into the life and teachings of Sai Baba. Located near the Sai Baba Temple, the museum showcases Sai Baba's personal belongings, including his robes, utensils, and photographs. The exhibits provide a glimpse into his simple, humble life, and the museum is a place where visitors can connect with his spirit and learn about his profound influence on the community."
        },
        {
          title: "Chavadi",
          description: "Chavadi is a historical building that served as Sai Baba's resting place during his later years. It holds great spiritual significance as this was where Sai Baba would often rest after his daily interactions with the devotees. Today, Chavadi is a popular site for devotees who want to experience Sai Baba's presence and gain insights into his modest and simple lifestyle. The building hosts a daily procession and remains a sacred spot for spiritual reflection."
        },
        {
          title: "Lendi Baug",
          description: "Lendi Baug is a beautiful garden that was frequented by Sai Baba for his daily prayers and meditation. This peaceful garden is an ideal spot for devotees to meditate and reflect in solitude. It houses a lamp that was lit by Sai Baba himself, symbolizing eternal peace and divine light. Lendi Baug continues to be a place of solace and spiritual renewal, attracting those seeking tranquility and blessings."
        },
        {
          title: "Shani Shingnapur",
          description: "Located about 70 km from Shirdi, Shani Shingnapur is a renowned pilgrimage site dedicated to Lord Shani, the deity associated with the planet Saturn. What makes the temple unique is its tradition of having no doors in the village houses, with locals believing that Lord Shani offers protection. Devotees come here to seek blessings for protection and prosperity, as the temple is known for its divine power and historical significance."
        },
        {
          title: "Sai Heritage Village",
          description: "Sai Heritage Village offers a glimpse into the past by recreating Shirdi as it was during Sai Baba’s time. This theme park aims to educate visitors about the saint’s life and teachings through historical replicas, artifacts, and exhibitions. It provides an immersive experience where visitors can witness the daily life and events from Sai Baba’s era, making it both an educational and spiritually enriching destination."
        },
        {
          title: "Khandoba Mandir",
          description: "Khandoba Mandir holds a special place in the spiritual journey of Sai Baba. It was here that Sai Baba was first recognized as a spiritual leader by the villagers. The temple is dedicated to Lord Khandoba, a regional deity, and is of immense historical and spiritual importance to Sai Baba’s followers. Visiting this temple offers insights into the early days of Sai Baba's life and his journey to becoming a revered saint."
        },
        {
          title: "Wet N Joy Water Park",
          description: "For families traveling with children or those seeking a fun, recreational break, Wet N Joy Water Park in Shirdi is a fantastic escape. The park features thrilling water rides, wave pools, slides, and other attractions, making it an ideal spot for relaxation after a spiritual pilgrimage. It's a place to enjoy some fun in the sun and unwind with family and friends."
        },
        {
          title: "Upasani Maharaj Ashram",
          description: "The Upasani Maharaj Ashram is dedicated to one of Sai Baba’s foremost disciples, Upasani Maharaj. Situated in a peaceful area, this ashram offers a tranquil environment for meditation, prayer, and spiritual practice. It is an important place for those seeking to deepen their spiritual connection and learn from the teachings of Upasani Maharaj, who played a vital role in the spiritual development of Shirdi."
        }
      ],


    services: [
  {
    "name": "Mumbai to Shirdi Taxi",
    description: "Looking for a reliable Mumbai to Shirdi taxi? AB Ghule Cabs offers comfortable and affordable taxi services for your journey to Shirdi. Our experienced drivers ensure a safe and pleasant ride, with well-maintained vehicles tailored to your needs."
  },
  {
    "name": "Mumbai to Shirdi Taxi Fare",
    description: "Check out the best Mumbai to Shirdi taxi fare with AB Ghule Cabs. Our transparent pricing ensures no hidden charges, offering competitive rates for your Shirdi trip. Whether it's a one-way or round trip, enjoy a hassle-free ride with our trusted services."
  },
  {
    "name": "Mumbai to Shirdi Car Rental",
    description: "Rent a car from Mumbai to Shirdi with AB Ghule Cabs. We offer a variety of well-maintained vehicles, from sedans to SUVs, for a comfortable and memorable journey to Shirdi. Book your car rental at affordable rates with flexible rental options."
  },
  {
    "name": "Mumbai to Shirdi Taxi Service",
    description: "AB Ghule Cabs offers efficient and reliable Mumbai to Shirdi taxi services. Our experienced drivers ensure a smooth ride, with modern and well-maintained vehicles equipped to make your trip comfortable. We provide the best services at competitive prices."
  },
  {
    "name": "Mumbai to Shirdi Taxi Cost",
    description: "Know the exact Mumbai to Shirdi taxi cost with AB Ghule Cabs. We provide a clear and competitive pricing structure, with no hidden fees. Whether it's a one-way trip or round trip, we guarantee the best value for your money."
  },
  {
    "name": "Mumbai to Shirdi Cab Service",
    description: "For a comfortable and reliable Mumbai to Shirdi cab service, AB Ghule Cabs is your go-to choice. Our cabs are well-maintained and equipped for a smooth ride. Enjoy a comfortable journey with experienced drivers ensuring your safety and convenience."
  },
  {
    "name": "Navi Mumbai to Shirdi Cab",
    description: "Traveling from Navi Mumbai to Shirdi? AB Ghule Cabs offers reliable and affordable cab services for your journey. Our well-maintained vehicles and professional drivers will ensure you have a smooth and comfortable trip to Shirdi."
  },
  {
    "name": "Thane to Shirdi Cab",
    description: "For a comfortable and affordable Thane to Shirdi cab service, AB Ghule Cabs is the best option. We provide a range of well-maintained vehicles with professional drivers for a hassle-free journey to Shirdi."
  },
  {
    "name": "Kalyan to Shirdi Cab Service",
    description: "AB Ghule Cabs offers reliable Kalyan to Shirdi cab services at competitive rates. Whether you're looking for a one-way trip or a round trip, we provide well-maintained vehicles and experienced drivers to ensure a safe and comfortable journey."
  },
  {
    "name": "Dadar to Shirdi Cab Service",
    description: "If you're traveling from Dadar to Shirdi, AB Ghule Cabs provides a convenient and affordable cab service. Our well-maintained vehicles and experienced drivers ensure that your journey is smooth and hassle-free, whether it's a one-way or round trip."
  },
  {
    "name": "Andheri to Shirdi Cab Service",
    description: "Need a reliable cab from Andheri to Shirdi? AB Ghule Cabs offers affordable and comfortable taxi services with professional drivers to ensure you travel safely and enjoyably to Shirdi."
  },
  {
    "name": "Mumbai to Shirdi Cab Booking Online",
    description: "Book your Mumbai to Shirdi cab online with AB Ghule Cabs. We offer easy online booking options for your convenience, ensuring a smooth and hassle-free booking experience. Choose from a variety of well-maintained vehicles suited to your needs."
  },
  {
    "name": "Mumbai to Shirdi Round Trip Taxi Fare",
    description: "For a round-trip taxi fare from Mumbai to Shirdi, AB Ghule Cabs offers transparent and competitive pricing. Our round trip services ensure that you have a comfortable and relaxing ride to and from Shirdi, with no hidden charges."
  },
  {
    "name": "Mumbai Airport to Shirdi Taxi Fare",
    description: "Book a taxi from Mumbai Airport to Shirdi with AB Ghule Cabs. Our taxi services are affordable and reliable, offering comfortable rides with professional drivers. Enjoy a smooth and efficient journey from the airport to Shirdi at the best rates."
  },
  {
    "name": "Mumbai to Shirdi Cabs Round Trip",
    description: "AB Ghule Cabs provides round trip services for your journey from Mumbai to Shirdi. Enjoy a comfortable ride with well-maintained vehicles and professional drivers ensuring a smooth trip. Our round-trip services are priced competitively to give you the best value."
  },
  {
    "name": "Mumbai to Shirdi Packages",
    description: "AB Ghule Cabs offers customized Mumbai to Shirdi packages to suit your travel needs. Our packages include comfortable cab services with experienced drivers, ensuring a hassle-free and enjoyable trip to Shirdi. Book a package that fits your schedule and budget."
  },
  {
    "name": "Mumbai to Shirdi Cab Contact Number",
    description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai to Shirdi Cab. We ensure a smooth and enjoyable ride for all our customers."
  }
],

tableData: [
    ["- Mumbai to Shirdi taxi", "- Mumbai to Shirdi taxi fare"],
    ["- Mumbai to Shirdi car rental", "- Mumbai to Shirdi taxi service"],
    ["- Mumbai to Shirdi taxi cost", "- Mumbai to Shirdi cab service"],
    ["- Navi Mumbai to Shirdi cab", "- Thane to Shirdi cab"],
    ["- Kalyan to Shirdi cab service", "- Dadar to Shirdi cab service"],
    ["- Andheri to Shirdi cab service", "- Mumbai to Shirdi cab booking online"],
    ["- Mumbai to Shirdi round trip taxi fare", "- Mumbai airport to Shirdi taxi fare"],
    ["- Mumbai to Shirdi Cabs round trip", "- Mumbai to Shirdi packages"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we take pride in providing reliable and professional Mumbai to Shirdi cab services. Our drivers are well-trained, courteous, and committed to offering you a safe and comfortable ride."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you're planning your trip to Shirdi early in the morning or late at night, we are available 24/7 to cater to your travel needs. Our customer service team is always ready to assist you with your booking."
    },
    {
      WhyChooseheading: "Affordable Rates",
      WhyChoosedescription: "We offer competitive and transparent fare structures, ensuring that you get value for your money without any hidden charges. Our pricing suits all budgets, whether you are traveling alone or in a group."
    },
    {
      WhyChooseheading: "Clean and Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are regularly cleaned, maintained, and inspected to ensure they are in perfect condition for your journey to Shirdi. We offer a range of vehicles, from budget-friendly to luxury options, to suit different preferences."
    },
    {
      WhyChooseheading: "Safe and Comfortable Rides",
      WhyChoosedescription: "We prioritize your safety with experienced, background-checked drivers. Our vehicles are equipped with GPS to ensure a smooth, safe ride through Mumbai's and Shirdi's busy roads."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a cab with AB Ghule Cabs is quick and easy. You can book your Mumbai to Shirdi cab online via our website or app, or simply call our customer service for immediate assistance."
    },
    {
      WhyChooseheading: "Customer Satisfaction",
      WhyChoosedescription: "We have a proven track record of customer satisfaction, with numerous positive reviews from our regular customers. We are committed to making your travel experience seamless and enjoyable."
    }
  ]
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai to Shirdi cab with AB Ghule Cabs?',
      answer: 'You can book a cab through our website, mobile app, or by calling our customer service helpline. We offer an easy and hassle-free booking process for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all our drivers are highly trained, experienced, and background-checked to ensure a safe and comfortable ride.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a wide range of vehicles, including sedans, SUVs, and luxury cars, to cater to different needs and preferences for your trip to Shirdi.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'You can pay for your ride through various options including cash, credit/debit cards, or online payment through our mobile app, giving you the flexibility to choose.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time or detours, depending on the nature of your trip. However, we ensure transparency in pricing, and any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can easily modify or cancel your booking through our website or app. If you need assistance, feel free to contact our customer service team.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer one-way and round-trip services?',
      answer: 'Yes, we offer both one-way and round-trip services for your Mumbai to Shirdi journey, allowing you to choose the best option based on your travel needs.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Yes, we offer spacious vehicles for group travel to Shirdi. Whether you\'re traveling with family, friends, or colleagues, we can accommodate your group comfortably.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other cab services?',
      answer: 'AB Ghule Cabs is known for its commitment to customer satisfaction, competitive pricing, experienced drivers, a wide range of vehicles, and excellent customer support. We aim to provide a personalized, safe, and comfortable experience for all our passengers.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Rajesh Bhat",
      feedback: "I recently hired a cab from AB Ghule Cabs for a trip to Shirdi, and I must say it was an amazing experience. The driver was punctual, the vehicle was comfortable and well-maintained, and we reached Shirdi without any delays. I will definitely use their service again for future trips.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Neha Gupta",
      feedback: "AB Ghule Cabs made my trip to Shirdi stress-free and enjoyable. The booking process was smooth, and the driver was professional and courteous. I highly recommend this service for anyone traveling to Shirdi from Mumbai.",
      rating: 5,
    },
  ];
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Shirdi Cab Service | Mumbai to Shirdi Taxi</title>
  <meta name="description" content="Affordable Mumbai to Shirdi cab service, offering various options including round trip taxi, car rentals, and taxi services from different Mumbai locations like Navi Mumbai, Thane, and Andheri to Shirdi." />
  <meta name="keywords" content="Mumbai to Shirdi Taxi, Mumbai to Shirdi Taxi Fare, Mumbai to Shirdi Car Rental, Mumbai to Shirdi Taxi Service, Navi Mumbai to Shirdi Cab, Thane to Shirdi Cab, Dadar to Shirdi Cab, Andheri to Shirdi Cab Service, Mumbai to Shirdi Cab Booking Online, Mumbai to Shirdi Round Trip Taxi Fare, Mumbai Airport to Shirdi Taxi Fare, Mumbai to Shirdi Packages" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Shirdi Cab Service | Mumbai to Shirdi Taxi" />
  <meta property="og:description" content="Affordable Mumbai to Shirdi cab service, offering various options including round trip taxi, car rentals, and taxi services from different Mumbai locations like Navi Mumbai, Thane, and Andheri to Shirdi." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-to-shirdi-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-to-shirdi-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Affordable Mumbai to Shirdi cab service, offering various options including round trip taxi, car rentals, and taxi services from different Mumbai locations like Navi Mumbai, Thane, and Andheri to Shirdi.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-to-shirdi-cab",
        "logo": "https://abghulecabs.com/images/mumbai-to-shirdi-cab.jpg",
        "image": "https://abghulecabs.com/images/mumbai-to-shirdi-cab.jpg",
        "priceRange": "₹3000 - ₹7000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-to-shirdi-cab",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Arvind Patel"
            },
            "datePublished": "2024-09-25",
            "reviewBody": "Excellent service for our trip from Mumbai to Shirdi. The cab was comfortable, and the driver was very professional."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya Deshmukh"
            },
            "datePublished": "2024-08-30",
            "reviewBody": "Booked a round trip taxi for Mumbai to Shirdi. The service was prompt and reliable. Highly recommend for anyone planning to visit Shirdi from Mumbai."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-to-shirdi-cab"
        },
        "keywords": "Mumbai to Shirdi Taxi, Mumbai to Shirdi Taxi Fare, Mumbai to Shirdi Car Rental, Mumbai to Shirdi Taxi Service, Navi Mumbai to Shirdi Cab, Thane to Shirdi Cab, Dadar to Shirdi Cab, Andheri to Shirdi Cab Service, Mumbai to Shirdi Cab Booking Online, Mumbai to Shirdi Round Trip Taxi Fare, Mumbai Airport to Shirdi Taxi Fare, Mumbai to Shirdi Packages"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/2.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitoshirdi;